import { ActionCreator } from 'app/redux/ActionCreator';
import { ActionTypes, IResourceAction, IResourceState } from 'app/redux/Resources/reducer';
import { SES } from 'aws-sdk';

class ResourceActionCreator extends ActionCreator<IResourceState, IResourceAction> {
  getFileUrl(username: string, apiKey: string, fileName: string) {
    return this.dispatchAsync((getState) => {
      return new Promise((resolve, reject) => {
        fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/downloadfile', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: apiKey,
          },
          body: JSON.stringify({
            fileName,
            username,
          }),
        })
          .then((result) => {
            result
              .json()
              .then((parsedJson) => {
                const resource: IResourceState = { username, fileName, url: parsedJson.url, error: null };
                const action = { type: ActionTypes.REQUESTREPORT, resource };
                resolve(action);
              })
              .catch((error) => {
                const resource: IResourceState = { username, fileName, url: '', error };
                const action = { type: ActionTypes.REQUESTREPORT, resource };
                reject(action);
              });
          })
          .catch((error) => {
            const resource: IResourceState = { username, fileName, url: '', error };
            const action = { type: ActionTypes.REQUESTREPORT, resource };
            reject(action);
          });
      });
    });
  }
}

const ResourceAction = new ResourceActionCreator();

export { ResourceAction, ResourceActionCreator };



// WEBPACK FOOTER //
// ./src/app/redux/Resources/actions/index.ts